import React from 'react';
import { SubtitleThree } from '@/styles/theme/default/typography';
import styled from 'styled-components';
import useSale, { saleStages } from '@/hooks/useSale';
import {useSelector} from "react-redux";
import { Link } from 'react-router-dom';

function BannerText({ onClick }) {
  const { saleStage, code } = useSale();

  const user = useSelector(state => state.Auth.user);
  const isTrade = [2].includes(parseInt(user.role_id));
  // const isTrade = true;

  const earlyAccessText = isTrade ? (
      <>
        Early Access - 30% off Sitewide. Exclusions apply.
      </>
    ) :
    <>
      Early Access -  25% off Sitewide. Exclusions apply.
    </>;

  const baseText = isTrade ? (
      <>
        Fourth of July Sale: 30% off Sitewide. Exclusions apply.
      </>
    ) :
    <>
      Fourth of July Sale: 25% off Sitewide. Exclusions apply.
    </>;

  // const lastChanceText = isTrade ? (
  //     <>
  //       Last Chance: 30% off Sitewide. Exclusions apply.
  //     </>
  //   ) :
  //   <>
  //     Last Chance: 25% off Sitewide. Exclusions apply.
  //   </>;
  //
  // const extensionText = isTrade ? (
  //     <>
  //       Back for a limited time: 30% off Sitewide. Exclusions apply.
  //     </>
  //   ) :
  //   <>
  //     Back for a limited time: 25% off Sitewide. Exclusions apply.
  //   </>;

  const lastDayText = isTrade ? (
      <>
        Last Chance: 30% off Sitewide. Exclusions apply.
      </>
    ) :
    <>
      Last Chance: 25% off Sitewide. Exclusions apply.
    </>;




  return (
    <SubtitleThree className="copy">
      {saleStage === saleStages.EARLY_ACCESS && earlyAccessText}
      {saleStage === saleStages.REGULAR && baseText}
      {saleStage === saleStages.LAST_CHANCE && <> {lastChanceText} </>}
      {saleStage === saleStages.SURPRISE_EXTENSION && <> {extensionText} </>}
      {saleStage === saleStages.LAST_DAY && lastDayText}
      {isTrade ?
        <SeeDetailsBtn onClick={onClick} className="see-details-btn">
          See Details
        </SeeDetailsBtn>
        : <Link to="/faq" className="see-details-btn" style={{marginLeft: '5px', textDecoration: 'underline', textTransform: 'capitalize', fontWeight: 'normal'}}>See Details</Link>}
    </SubtitleThree>
  );
}

const SeeDetailsBtn = styled.button`
  background: transparent;
  border: none;
  color: ${props => props.theme.colors.charcoal};
  font-weight: normal;
  letter-spacing: 0.12em;
  margin: 0 0 0 5px;
  padding: 0;
  text-decoration: underline;
`;

export default BannerText;
